export default "__VITE_ASSET__5a6907b6__"